const result = document.getElementById('result');
const filter = document.getElementById('filter');
const listItems = [];
var base_url='https://alzfaf.com/shopify_app/';
var shop='bait-altarfeeh.myshopify.com';
var url_string = window.location.href
var url = new URL(url_string);
var page = url.searchParams.get("page");
var view='list';
if(getCookie('view_style')!='null'){
  view=getCookie('view_style');
}
var lang=$("#language_localization").val();
$(document).ready(function(){
    $.ajax({ 
        dataType:'jsonp html',
        jsonpCallback: "processData",
        url: base_url+"ajax.php?shop="+shop+"&action=kids_club_list&page="+page+"&view="+view+"&lang="+lang+"&callback=?",
    });
  
});
function processData(json){
  console.log(json);
    $(".ajax-response").html(json.html);
}

function filter_apply(data){

  if (data.filter_value == 'All') {
    $.ajax({ 
        dataType:'jsonp html',
        jsonpCallback: "processData",
        url: base_url+"ajax.php?shop="+shop+"m&action=kids_club_list&page="+page+"&view="+view+"&lang="+lang+"&callback=?",
    });
  }else{
    $.ajax({ 
        dataType:'jsonp html',
        jsonpCallback: "processData",
        url:base_url+"ajax.php?shop="+shop+"&action=kids_club_list&page="+page+"&view="+view+"&lang="+lang+"&filter_name=" + data.filter_name + "&filter_value=" + data.filter_value+"&callback=?",
    });
  }
}

$('.view_info').on('click', function(e) {
      var selectedOption = $(this).attr('data-hub-name');
      window.dataLayer.push({
        event: 'viewInfoSelection',
        selectedViewInfo: selectedOption
      });
});

//filters          
$('#filter_activity').on('change', function() {
    var selectMenu = $('#filter_activity');

    var callback = function(e) {
      var selectedOption = this.value;
      window.dataLayer.push({
        event: 'activitySelection',
        selectedActivity: selectedOption
      });
    };
    selectMenu.on('change', callback);   
    var data = {filter_name:'activity', filter_value: this.value};
    filter_apply(data);
});

$('#filter_emirate').on('change', function() {
    var selectMenu = $('#filter_emirate');
    var callback = function(e) {
      var selectedOption = this.value;
      window.dataLayer.push({
        event: 'emirateSelection',
        selectedEmirate: selectedOption
      });
    };
  var data = {filter_name:'emirates', filter_value: this.value};
  filter_apply(data);
});
$('#filter_age').on('change', function() {
    var selectMenu = $('#filter_age');
    var callback = function(e) {
      var selectedOption = this.value;
      window.dataLayer.push({
        event: 'ageSelection',
        selectedAge: selectedOption
      });
    };
   var data = {filter_name:'age_group', filter_value: this.value};
  filter_apply(data);
});

$('#result').children().each((i, v) => listItems.push(v))

filter.addEventListener('keydown', (e) => {
  if (e.keyCode == 13) {
    var data = {filter_name:'title', filter_value: e.target.value};
     filter_apply(data);
  }

})

$(".filter_search").click(function(){
    var data = {filter_name:'title', filter_value: $(".search_keyword").val()};
    filter_apply(data);
})

function addNoResult() {
  if (!$('#no_result').length) {
    $('.users-list').append('<li id="no_result">No Results found, please try with a different filter</li>')
  }
}

function getHiddenEl() {
    var hiddenEls = 0;
    listItems.forEach(li => {
        if ($(li).hasClass('hide')) {
           hiddenEls ++;  
        }
    });
    return hiddenEls;
}

function filterData(searchTerm) {
  listItems.forEach(item => {
    if(item.innerText.toLowerCase().includes(searchTerm.toLowerCase())) {
      item.classList.remove('hide');
    } else {
      item.classList.add('hide');
    }
  });
    if (getHiddenEl() == listItems.length) {
        $('#no_result').show();
    } else {
        $('#no_result').hide();
    }
}

function filterAllData() {
  listItems.forEach(item => {
    $('#no_result').hide();
    $(item).removeClass('hide');
  });
}

function toggleListView() {
  console.log('list view')
}

function toggleGalleryView() {
  console.log('gallery view')
		$.ajax({
			//url: 'index.php?route=extension/module/kids_club&kids_default_view=gallery_view',
			dataType: 'json',
			success: function(json) {

			}
    })
}
function filterRequest(data) {
		$.ajax({
			url: 'index.php?route=extension/module/kids_club/filterClub&filter_name=' + data.filter_name + '&filter_value=' + data.filter_value,
			dataType: 'json',
			success: function(json) {
        console.log(json)
			}
    })
}
 function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
$(".view_btn").click(function(){
  setCookie('view_style',$(this).attr('title'),'1');
});